export default "__VITE_ASSET__DYzbMPNq__"